import React from 'react';
import { policyAreasAPI } from '../api/client';
import LookupMultiSelect from './LookupMultiSelect';

/** Active Policy Areas -- cross-cutting subject categories for a document. */
function PolicyAreaMultiSelect({ selectedIds, onChange }) {
  return (
    <LookupMultiSelect
      fetchItems={() => policyAreasAPI.getSelectable()}
      selectedIds={selectedIds}
      onChange={onChange}
      placeholder="All policy areas"
      emptyMessage="No policy areas defined yet. Add one under Admin → Policy Areas."
    />
  );
}

export default PolicyAreaMultiSelect;
